 <template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
              placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.planName" label="计划名称" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planType" label="检查类型" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planPeriod" label="检查周期" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="this.dateinfo" label="检查日期" v-if="inputForm.planPeriod!='每天'" label-width='100px'
          readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.days" label="检查工期" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planStartDate" label="计划有效期(起)" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planEndDate" label="计划有效期(止)" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="检查标准" name="2">
        <van-field v-model="inputForm.standardName" label="标准名称" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionLevelLabel" label="检查级别" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="standardData.frequency" label="检查频次" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="standardData.evaluationModeName" label="考核方式" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.planMethodLabel" label="检查方式" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="检查项目" name="3">
        <table>
          <thead>
            <tr>
              <td style="width: 50%;">检查项目</td>
              <td style="width: 50%;">评定人</td>
              <td style="width: 50%;">总分占比（%）</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in this.inputForm.moduleList">
              <td v-text="data.projectName"></td>
              <td v-text="data.checkUserName"></td>
              <td v-text="data.scoreRatio+'%'"></td>
            </tr>
          </tbody>
        </table>
      </van-collapse-item>

    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>
  
<script>
import QualityPlanService from '@/api/quality/QualityPlanService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById} from '../../api/quality/QualityInspectionStandard'
import processRecord from "../../components/processRecord/processRecord";
export default {
  data() {
    return {
      dateinfo: '',
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        checkusername: '',
        scoreratio: '',
        standardName: '',
        frequency: '',
        levelname: '',
        id: '',
        projectId: '',
        projectName: '',
        customerId: '',
        customerName: '',
        houseId: '',
        houseName: '',
        feeItemNames: '',
        exchangeId: '',
        planMethod: '',
        dateOne: '',
        dateWeek: '',
        dateMonth: '',
        code: '',
        status: '',
        remarks: '',
        createDate: '',
        createByName: {
          id: ''
        },
        isDoTask: false,
        isLastTask: false,
        attachIds: [],
        attachList: [],
        reason: '',
      },
      standardData: {},
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  mounted() {
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    is() {
      this.isEnabled = this.inputForm.isEnabled == '1' ? '启用' : '停用'
    },
    init(id) {
      new QualityPlanService().queryQualityPlanById(id).then(({ data }) => {
        if (data.planType == 11) {
          data.planType = '日常检查'
        } else if (data.planType == 12) {
          data.planType = '专项检查'
        } else {
          data.planType = '飞行检查'
        }
        if (data.planPeriod == 1) {
          data.planPeriod = '每天'
        } else if (data.planPeriod == 2) {
          data.planPeriod = '每周'
          this.dateinfo = data.dateWeek
        } else if (data.planPeriod == 3) {
          data.planPeriod = '每月'
          this.dateinfo = data.dateMonth
        } else {
          data.planPeriod = '指定日期'
          this.dateinfo = data.dateOne
        }

        this.inputForm = data

        queryById(data.standardId).then((res) => {
          this.standardData = res.data
        })
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new QualityPlanService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
		  //更新数据库状态
		  _this.inputForm.flowType = 3;
		  new DeratedService().startFlow(_this.inputForm);
		  
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>
  